import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  modalContent: theme => css`
    padding: ${theme.spacing.xs} 0;

    @media (max-width: 639px) {
      max-height: 220px;
      overflow: auto;
    }
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.xs};
    p {
      font-size: ${theme.fontSizes.md};
    }
  `,
})

export default useStyles
